<div class="pcf-container">
  @if (!isUserExternalSupplier) {
    <mds-button-toggle
      class="history-toggle"
      [checkedButton]="historySelectedTab"
      [multiple]="false"
      [options]="historyTabs"
      (change)="onSwitchViewHistory($event)"
    ></mds-button-toggle>
  }
  @if (historySelectedTab === campaignTabs.QUESTIONNAIRES) {
    <mds-button-toggle
      (change)="onSwitchView($event)"
      [checkedButton]="selectedTab"
      [multiple]="false"
      [name]="'CBAM'"
      [options]="tabs"
    ></mds-button-toggle>
    <div>
      <app-table-header
        [desc]="''"
        [icon]="{ key: tab.key === 'site_info' ? icons.FACTORY : icons.PRODUCT_INFORMATION }"
        [title]="tab?.name ?? ''"
      ></app-table-header>
      @if (selectedTab) {
        <ngx-masonry [ordered]="true">
          <div class="questionnaire-container">
            @if (!tab.isGrid) {
              <mat-accordion>
                @for (section of tab.sections; track section; let i = $index) {
                  <mat-expansion-panel
                    (closed)="panelOpenState[i] = false"
                    (opened)="panelOpenState[i] = true"
                    [expanded]="panelOpenState[i]"
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ section?.name }}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-card class="cbam-card">
                      <mat-card-content>
                        <form [formGroup]="sectionForms[i]">
                          <formly-form [fields]="sectionTypes[i]" [form]="sectionForms[i]"></formly-form>
                        </form>
                      </mat-card-content>
                    </mat-card>
                    <div class="actions">
                      @if (tab?.sections?.[0]?.actions?.edit) {
                        <mds-button (click)="onSubmit(i)" [type]="'primary'">Save Answers</mds-button>
                      }
                    </div>
                  </mat-expansion-panel>
                }
              </mat-accordion>
            }
          </div>
        </ngx-masonry>
      }
    </div>
  }
  @if (historySelectedTab === campaignTabs.HISTORY) {
    <app-request-history class="campaign__history" [rid]="rid"></app-request-history>
  }
</div>
